import {api, apiGateway} from "api/config";

class userService {

    getUserRegistrationSteps(id: string) {
        return api.get(`${process.env.REACT_APP_LEGACY_APP_URL}/api/internal/v1/users/${id}/progress`);
    }

    getUserInfo() {
        return api.get(`${process.env.REACT_APP_LEGACY_APP_URL}/api/v1/user/info`)
    }

    getUserSettings() {
        return api.get(`${process.env.REACT_APP_LEGACY_APP_URL}/api/v1/user/settings`)
    }

    postUserSettings(data: any) {
        return api(`${process.env.REACT_APP_LEGACY_APP_URL}/api/v1/user/settings/save`, {
            method: "POST",
            headers: {
                Accept:         "application/json, text/plain, */*",
                "Content-Type": "application/json",
            },
            // @ts-ignore
            data: JSON.stringify(data)
        })
    }

    getUserCuratorInfo() {
        return api.get(`${process.env.REACT_APP_LEGACY_APP_URL}/api/internal/v1/user/info/curator`)
    }

    async saveActualChatSessionId<T>(data: T) {
        return api(`${process.env.REACT_APP_LEGACY_APP_URL}/api/v1/user/chat/save-actual-session-id`, {
            method: "POST",
            headers: {
                Accept:         "application/json, text/plain, */*",
                "Content-Type": "application/json",
            },
            // @ts-ignore
            data: JSON.stringify(data)
        })
    }

}

export default new userService();